export default __webpack_public_path__ + "1877aa35d5ccfdcc4a2fae11cd894ebe.png";